import { useCallback } from 'react';
import { SelectFitlerProps as SelectFitlerComponentProps } from '@blockanalitica/ui/package/types/src/components/atoms/SelectFilter';
import { Dropdown, DropdownOption } from '@blockanalitica/ui';

type SelectFilterProps = SelectFitlerComponentProps & {
  initialValue?: string | null;
};

export default function SelectFilter({
  filterField = 'selectedOption',
  updateFilters,
  pagination,
  placeholder,
  options,
  initialValue
}: SelectFilterProps) {
  const onChange = useCallback(
    (value: string) => {
      updateFilters({
        [filterField]: value
      });

      if (pagination?.onPageChange) {
        pagination.onPageChange(1);
      }
    },
    [filterField, pagination, updateFilters]
  );

  return (
    <Dropdown
      placeholder={placeholder}
      onChange={onChange}
      initialValue={initialValue}>
      {options.map((option, index) => (
        <DropdownOption value={option.value} key={index}>
          {option.label}
        </DropdownOption>
      ))}
    </Dropdown>
  );
}
